import { Box } from '@mui/material';
import { isSavedFragment } from '../../../../fragments/types';
import { EditorTitle } from './components/EditorTitle';
import { EmptyEditor } from './components/EmptyEditor';
import { FragmentCreatedPanel } from './components/overview/FragmentCreatedPanel';
import { EditorChunksList } from './components/stream/EditorChunksList';
import { CreateJointFragmentBtn } from './components/toolbar/CreateJointFragmentBtn';
import { useFragmentEditorStore } from './stores/useFragmentEditorStore';

/**
 * Main view for the joint fragment editor.
 * Shows empty state, created state, or the list of editable chunks.
 */
export function EditorView() {
  const fragment = useFragmentEditorStore((state) => state.fragment);

  if (!fragment) {
    return <Box />;
  }

  const isEmpty = !fragment.chunks.length;

  return (
    <Box sx={{ mt: 3 }}>
      {isEmpty ? (
        <EmptyEditor />
      ) : isSavedFragment(fragment) ? (
        <FragmentCreatedPanel fragment={fragment} />
      ) : (
        <Box sx={{ mt: 4 }}>
          <Box sx={{ mb: 2, display: 'flex' }}>
            <EditorTitle />
          </Box>
          <EditorChunksList />
          <Box mt={4}>
            <CreateJointFragmentBtn />
          </Box>
        </Box>
      )}
    </Box>
  );
}
